<template>
  <div class="home-view">
    <Banner :image-list="bannerImages" :image-alt-list="bannerAltList" :duration="5000" />
    <div class="bg">
      <img src="https://ustatic.hudongmiao.com/miao/common/bar-bg_1769051824469cec2d3.webp" alt="" />
    </div>
    <IndexContent1 />
    <IndexContent2 />
    <IndexContent3 />
    <IndexContent4 />
    <div class="go-container">
      <div class="go-btn" @click="handleGoClick">
        立即开启智能酒吧之旅
      </div>
    </div>
    <!-- 悬浮二维码按钮 -->
    <div class="float-qrcode-wrapper">
      <FloatQrcode />
    </div>
    <HomeFooter v-if="showFooter" />
  </div>
</template>

<script>
import Banner from '@/components/Banner/Banner.vue';
import IndexContent1 from '@/components/IndexContent1/IndexContent1.vue';
import IndexContent2 from '@/components/IndexContent2/IndexContent2.vue';
import IndexContent3 from '@/components/IndexContent3/IndexContent3.vue';
import IndexContent4 from '@/components/IndexContent4/IndexContent4.vue';
import FloatQrcode from '@/components/FloatQrcode/FloatQrcode.vue';
import HomeFooter from '@/components/HomeFooter/HomeFooter.vue';
import { mapState } from 'vuex';

export default {
  name: 'HomeView',
  components: {
    Banner,
    IndexContent1,
    IndexContent2,
    IndexContent3,
    IndexContent4,
    FloatQrcode,
    HomeFooter,
  },
  computed: {
    ...mapState(['bannerImages']),
    bannerAltList() {
      return ['专业的酒吧霸屏互动游戏点歌系统'];
    },
    showFooter() {
      // 从当前路由和父路由中查找 showFooter
      const { matched } = this.$route;
      for (let i = matched.length - 1; i >= 0; i -= 1) {
        if (matched[i].meta?.showFooter !== undefined) {
          return matched[i].meta.showFooter;
        }
      }
      return false;
    },
  },
  methods: {
    handleGoClick() {
      // 打开新页面跳转到在线体验地址
      const url = this.$store.state.demoActivityURL;
      if (url) {
        window.open(url, '_blank');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.home-view {
  position: relative;
  z-index: 0; // 创建局部层叠上下文，方便控制内部层级
  width: 100%;
  margin: 0 auto;
  min-height: 100vh;
  padding-top: 62px;
  background: #000;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;

  .bg {
    position: absolute;
    top: 522px; // padding-top(62px) + Banner高度(460px)，使背景图像从 Banner 下方开始显示
    left: 0;
    right: 0;
    width: 100%;
    z-index: 1; // 背景层，低于其他内容(z-index: 2)
    pointer-events: none; // 确保不影响其他元素的交互

    img {
      width: 100%;
      height: auto;
      object-fit: contain; // contain模式，完整显示图片，保持宽高比
      display: block;
    }
  }

  .go-container {
    width: 1150px;
    height: 169px;
    margin-top: 80px;
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(270deg,
        rgba(102, 27, 135, 0.5) 0%,
        rgba(20, 79, 139, 0.5) 100%);

    .go-btn {
      width: 385px;
      height: 55px;
      border-radius: 28px;
      background: linear-gradient(270deg, #CD5DFB 0%, #7249FF 100%);
      box-shadow: inset 0px 4px 10px 0px rgba(255, 255, 255, 0.6);
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 500;
      font-size: 28px;
      color: #FFFFFF;
      cursor: pointer;
    }
  }

  // 让除浮动二维码容器和背景容器以外的所有直接子元素都在其之上
  >*:not(.float-qrcode-wrapper):not(.bg) {
    position: relative;
    z-index: 2;
  }

  // 悬浮二维码按钮的外层容器，不参与内部层级控制
  .float-qrcode-wrapper {
    position: static;
    z-index: auto;
  }
}
</style>
